import { Component, OnInit, Input } from "@angular/core";
@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.css"],
})
export class ToastComponent implements OnInit {
  @Input() duration: number = 1500;
  @Input() message: string;
  @Input() success: boolean;
  @Input() warning: boolean;
  @Input() error: boolean;

  constructor() {}
  ngOnInit(): void {
  }
  showToast = false;
  timeoutId: any;

  showMessage(message: string, message_type: string): void {
    switch (message_type) {
      case "success":
        this.success = true;
        this.warning = false;
        this.error = false;
        break;
      case "warning":
        this.success = false;
        this.warning = true;
        this.error = false;
        break;
      case "error":
        this.success = false;
        this.warning = false;
        this.error = true;
        break;
    }
    this.message = message;
    this.showToast = true;

    this.hideMessage();
  }

  hideMessage(): void {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.showToast = false;
    }, this.duration);
  }
}
